import { FanActivity } from "@/services/bedrock";

const ACTIVITY_TYPE_LABELS: Record<string, string> = {
  review_received: "Review Received",
  form_request_sent: "Form Requested",
  form_response_submitted: "Response Submitted",
  fan_merged_from: "Merged From",
  fan_merged_into: "Merged Into",
  player_changed: "Player Changed",
};

/** The activity as the Fans table and the activity history both show it. Metadata keys arrive camelCased. */
export function fanActivityLabel(activity: Pick<FanActivity, "activityType" | "metadata">): string {
  const metadata = activity.metadata ?? {};
  switch (activity.activityType) {
    case "possible_duplicate_email":
      return `Submitted a form with a different email: ${metadata.email ?? ""}`.trim();
    case "response_moved_from":
      return `Form response moved to ${metadata.toFanDisplayName || "another Fan"}`;
    case "response_moved_to":
      return `Form response moved here from ${metadata.fromFanDisplayName || "another Fan"}`;
    default:
      return ACTIVITY_TYPE_LABELS[activity.activityType] || activity.activityType;
  }
}
